export enum Links {
  HOME = '/',
  TOKEN = '/token',
  NFT = '/nft',
  CREATE = '/create',
}

export enum TokenSubLinks {
  APPROVAL = 'approval',
  AIRDROP = 'airdrop',
  TUTORIAL = 'tutorial',
  FAQ = 'faq',
}

export const docs = {
  // TODO: change this link
  terms: 'https://t.me/mad-assembly',
}

export const socials = {
  DISCORD: 'https://discord.gg/y9TSwr2Swk',
  TWITTER: 'https://twitter.com/_madAssembly',
}

//todo типизировать когда будем добавлять роуты для нфт
export const getTokenSubLink = (subKey: TokenSubLinks) => {
  return `${Links.TOKEN}/${subKey}`
}
